import { ListClinic } from '@chiroup/core/types/Clinic.type';
import React, { useState } from 'react';
import SimpleTabs from '../../../layout/SimpleTabs';
import AutomationPanel from './AutomationPanel';
import BillingProfilePanel from './BillingProfilePanel';

type Props = {
  clinic: Partial<ListClinic>;
};

const tabs = [{ name: 'Billing Profiles' }, { name: 'Automation' }];

const ClinicDebug: React.FC<Props> = ({ clinic }) => {
  const [selectedTab, setSelectedTab] = useState('Billing Profiles');

  return (
    <div>
      <SimpleTabs tabs={tabs} onSelectTab={setSelectedTab} selectedTab={selectedTab} />
      <div className="p-6 space-y-8">
        {selectedTab === 'Billing Profiles' ? (
          <BillingProfilePanel clinicId={clinic.ID!} />
        ) : selectedTab === 'Automation' ? (
          <AutomationPanel
            clinicId={clinic.ID as number}
            timezone={clinic.locations?.[0]?.timezone ?? undefined}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ClinicDebug;
